<template>
  <BaseImage
    :src="src"
    :alt="alt"
    :image-class="imageClass"
    fallback-src="/static/images/avatars/avatar_01.svg"
  />
</template>
<script setup>
import BaseImage from '@/components/image/BaseImage.vue';

defineProps({
  src: {
    type: String,
    default: '',
  },
  alt: {
    type: String,
    default: 'user',
  },
  imageClass: {
    type: [Object, Array, String],
    default: '',
  },
});
</script>
